<div class="row filter">
  <div class="label" *ngIf="!hideFilterLabel">Filter:</div>
  <div class="wrapper" [ngClass]="{'left-16': hideFilterLabel}">
    <div class="chips">
      <ng-container *ngFor="let chip of chips">
        <chip
          class="chip"
          *ngIf="isChip(chip)"
          [model]="chip"
          (edit)="emitInputChanged()"
          (remove)="removeChip($event)"
          [isAnalytics]="isAnalytics"
        ></chip>
        <operator
          class="operator"
          *ngIf="isOperator(chip)"
          (edit)="emitInputChanged()"
          [model]="chip"
        ></operator>
      </ng-container>
      <input
        autocomplete="off"
        #input
        class="filter-input"
        [placeholder]="placeholder"
        (keydown)="onKeyDown($event)"
        (keyup)="useAutoSuggest && onKeyUp($event)"
        (keydown.arrowdown)="onArrowDown()"
      />
    </div>
  </div>
</div>
<auto-suggest
  *ngIf="autoSuggestService.dataSource | async as dataSource"
  class="auto-suggest"
  [dataSource]="dataSource"
  (onClick)="$event && onSuggestClick($event)"
  [isAnalytics]="isAnalytics"
></auto-suggest>
